<template>
  <div>
    <!-- 2. Correct answers -->
    <div
      class="form-check form-check-inline"
      v-if="slideActive.type == 'multipleChoice' || slideActive.type == 'imageChoice'"
    >
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-correct-option"
          v-model="slideActive.addCorrectOption"
          @change="$emit('updateSettingSlide', 4)"
        >
        <label
          class="custom-control-label"
          for="check-correct-option"
        >This question has correct answer(s)</label>
        <span class="pl-1 title-table-presentation-tooltip tooltip-on-hover">
          <b-button
            v-tooltip="'Mark one or more options as correct and reveal them to your participants.'"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
    </div>

    <div
      class="mr-0 form-check form-check-inline"
      v-if="slideActive"
    >
      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          id="check-multiple-choice"
          :checked="slideActive.multipleChoice"
          @change="$emit('updateSettingSlide', 1)"
        >
        <label
          class="custom-control-label"
          for="check-multiple-choice"
        >Allow picking more than one option</label>
        <span
          class="pl-1 title-table-presentation-tooltip tooltip-on-hover"
        >
          <b-button
            v-tooltip="pickmoreTooltip"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
      <div class="pt-2 horizontal layout center justified" v-if="isMultipleOptionsCanPickVisible">
        <div class="multiple-options-label">
          Each participant can pick
        </div>
        <div
          class="relative multiple-options-content horizontal layout center"
        >
          <aha-input
            type="number"
            v-model="slideActive.limitChoice"
            @input="handleChangeLimitChoice()"
            :error="isErrorLimitChoiceVisible"
            class="mr-3"
          />
          <div class="absolute top-2.5 right-15 text-base-70">
            options
          </div>
          <div class="multiple-options-box"></div>
        </div>
      </div>

      <div
        class="pick-option-point"
        v-if="slideActive.type == 'pickAnswer' && slideActive.multipleChoice"
      >
        <div class="form-check form-check-inline">
          <div class="custom-control custom-checkbox">
            <input
              type="radio"
              class="custom-control-input"
              name="pick-more-point"
              value="false"
              id="pick-answer-nopoint"
              v-model="slideActive.isCorrectGetPoint"
              @change="$emit('updateSettingSlide', 13)"
            >
            <label class="custom-control-label" for="pick-answer-nopoint">
              Must not miss any
            </label>
            <span
              class="pl-1 title-table-presentation-tooltip tooltip-on-hover"
            >
              <b-button
                v-tooltip="mustNotMissAnyTooltip"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>

        <div class="form-check form-check-inline">
          <div class="custom-control custom-checkbox">
            <input
              type="radio"
              class="custom-control-input"
              name="pick-more-point"
              value="true"
              id="pick-answer-morepoint"
              v-model="slideActive.isCorrectGetPoint"
              @change="$emit('updateSettingSlide', 13)"
            >
            <label class="custom-control-label" for="pick-answer-morepoint">
              The more the better
            </label>
            <span
              class="pl-1 title-table-presentation-tooltip tooltip-on-hover"
            >
              <b-button
                v-tooltip="theMoreTheBetterTooltip"
                class="tooltip-btn"
              />
              <i class="fas fa-question-circle" />
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    isSlideQuiz() {
      return this.slideActive.type === 'pickAnswer'
    },
    mustNotMissAnyTooltip() {
      return 'Players must choose all correct answers to score points'
    },
    theMoreTheBetterTooltip() {
      return 'Players score more points the more correct answers they choose. If they choose any incorrect answer, they score 0 points.'
    },
    pickmoreTooltip() {
      if (this.slideActive.type === 'pickAnswer') {
        return 'Players must choose more than one correct answer to score more points'
      }
      return 'Your audience can vote for 2 or more options in the poll'
    },
    isMultipleOptionsCanPickVisible() {
      const { type, multipleChoice } = this.slideActive
      return (type == 'imageChoice' || type == 'multipleChoice')
          && multipleChoice
          && this.getMaxLimitOption() >= 2
    },
    isErrorLimitChoiceVisible() {
      const { limitChoice } = this.slideActive
      return !limitChoice ||
      limitChoice < 2 ||
        limitChoice > this.getMaxLimitOption()
    },
  },

  watch: {
    isMultipleOptionsCanPickVisible: function watchLimitChoice() {
      if (this.slideActive.limitChoice > this.getMaxLimitOption()) {
        this.slideActive.limitChoice = this.getMaxLimitOption()
      }
      this.$emit('updateSettingSlide', 2)
    },
  },

  methods: {
    getMaxLimitOption() {
      let count = 0
      this.slideActive.SlideOptions.forEach((item) => {
        if (item.id) count++
      })
      return count
    },
    handleChangeLimitChoice() {
      const { limitChoice } = this.slideActive
      if (!limitChoice || limitChoice < 2) return
      if (limitChoice > this.getMaxLimitOption()) {
        this.$store.state.slideActive.limitChoice = 1
      }
      if (this.isErrorLimitChoiceVisible) return
      this.$emit('updateSettingSlide', 2)
    },
  },

}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";

.pick-option-point {
  padding-left: 23px;
  .form-check-inline {
    margin: 12px 0;
  }
}

.label-option-small {
  font-size: 14px !important;
  color: #313131 !important;
  padding-left: 10px;
  padding-left: 23px;
  font-weight: normal;
}

.multiple-options-label {
  padding-left: 1.5rem;
}

.multiple-options-content {
  & ::v-deep .aha-input {
    width: 121px;
    padding-right: 60px;
  }
  .multiple-options-box {
    width: 35px;
    height: 35px;
  }
}
</style>
